import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    OnDestroy,
    OnInit,
    ViewEncapsulation,
} from '@angular/core';
import { Subscription } from 'rxjs';

import { ToastOutletOptions, ToastOutletService } from './toast-outlet.service';

@Component({
    selector: 'mapp-toast-outlet',
    templateUrl: 'toast-outlet.component.html',
    styleUrls: ['toast-outlet.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export default class ToastOutletComponent implements OnInit, OnDestroy {
    isOpen = false;

    type: string;

    title: string;

    message: string;

    icon: ToastOutletOptions['icon'];

    private timeoutCounter;

    private subscription = new Subscription();

    /**
     *
     * @param toastService
     * @param cdr
     */
    constructor(
        private readonly toastService: ToastOutletService,
        private cdr: ChangeDetectorRef
    ) {}

    /**
     *
     */
    ngOnInit() {
        this.subscription.add(
            this.toastService.onCreate.subscribe((options: ToastOutletOptions) => {
                this.type = options.type;
                this.title = options.title;
                this.message = options.message;
                this.icon = options.icon;
                this.isOpen = true;

                if (options.dismissAfter) {
                    this.timeoutCounter = setTimeout(
                        () => this.handleClose(),
                        options.dismissAfter
                    );
                }

                this.cdr.detectChanges();
            })
        );
    }

    /**
     *
     */
    ngOnDestroy() {
        this.subscription.unsubscribe();
        clearTimeout(this.timeoutCounter);
        this.isOpen = false;
    }

    /**
     *
     */
    handleClose() {
        this.isOpen = false;
        this.cdr.detectChanges();
    }
}
